import data_heroes from '@/data/cards/data_heroes'
import data_enemies from '@/data/cards/data_enemies'
import data_weapons from '@/data/cards/data_weapons'
import data_shields from '@/data/cards/data_shields'
import data_items from '@/data/cards/data_items'
import data_scrolls from '@/data/cards/data_scrolls'
import data_traps from '@/data/cards/data_traps'
import data_talismans from '@/data/cards/data_talismans'

export default [
	...data_heroes,
	...data_enemies,
	...data_weapons,
	...data_shields,
	...data_items,
	...data_scrolls,
	...data_traps,
	...data_talismans,
	
	{
		type: 'gold',
		slug: 'emerald',
		levels: [
			{ gold: 1 },
			{ gold: 2 },
			{ gold: 3 },
		],
		targets: [ 'empty' ],
		fr: { name: "Émeraude", description: "Confère (X) émeraude(s)." },
		en: { name: "Emerald", description: "Gives (X) emerald(s)." }
	},
]